"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var activityLog = require("./api/activity-log/activity-log");
exports.activityLog = activityLog;
var activityLogSleep = require("./api/activity-log/activity-log-sleep");
exports.activityLogSleep = activityLogSleep;
var activityLogTypes = require("./api/activity-log/activity-log-types");
exports.activityLogTypes = activityLogTypes;
var authToken = require("./api/auth-token");
exports.authToken = authToken;
var calorieTargets = require("./api/calorie-targets/calorie-targets");
exports.calorieTargets = calorieTargets;
var console = require("./api/console/console");
exports.console = console;
var dailyGoal = require("./api/daily-goal/daily-goal");
exports.dailyGoal = dailyGoal;
var event = require("./api/event/event");
exports.event = event;
var foodLog = require("./api/food-log/food-log");
exports.foodLog = foodLog;
var listWorkout = require("./api/list-workout/list-workout");
exports.listWorkout = listWorkout;
var activityRecommendation = require("./api/recommendation/activity-recommendation");
exports.activityRecommendation = activityRecommendation;
var calorieRecommendation = require("./api/recommendation/calorie-recommendation");
exports.calorieRecommendation = calorieRecommendation;
var mealRecommendation = require("./api/recommendation/meal-recommendation");
exports.mealRecommendation = mealRecommendation;
var sleepRecommendation = require("./api/recommendation/sleep-recommendation");
exports.sleepRecommendation = sleepRecommendation;
var stepRecommendation = require("./api/recommendation/step-recommendation");
exports.stepRecommendation = stepRecommendation;
var workoutRecommendation = require("./api/recommendation/workout-recommendation");
exports.workoutRecommendation = workoutRecommendation;
var request = require("./api/request");
exports.request = request;
var shoeLog = require("./api/shoe-log/shoe-log");
exports.shoeLog = shoeLog;
var userLog = require("./api/user-log/user-log");
exports.userLog = userLog;
var user = require("./api/user/user");
exports.user = user;
var userBilling = require("./api/user/user-billing");
exports.userBilling = userBilling;
var userFollow = require("./api/user/user-follow");
exports.userFollow = userFollow;
var userPreferences = require("./api/user/user-preferences");
exports.userPreferences = userPreferences;
var userSettings = require("./api/user/user-settings");
exports.userSettings = userSettings;
var userShipping = require("./api/user/user-shipping");
exports.userShipping = userShipping;
var workout = require("./api/workout/workout");
exports.workout = workout;
var workoutGroup = require("./api/workout/workout-group");
exports.workoutGroup = workoutGroup;
var client_1 = require("./api/client");
exports.IfitApiClient = client_1.IfitApiClient;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ifit/ifit-api-v1/out/index.js
// module id = 356
// module chunks = 0